import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { SharePermission } from "../../lib/types";

interface SharePermissionToggleProps {
  value: SharePermission;
  onChange: (value: SharePermission) => void;
}

const SharePermissionToggle: React.FC<SharePermissionToggleProps> = ({
  value,
  onChange,
}) => {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      size="small"
      onChange={(_, nextValue) => {
        if (nextValue) {
          onChange(nextValue);
        }
      }}
    >
      <ToggleButton value="view">View</ToggleButton>
      <ToggleButton value="edit">Edit</ToggleButton>
    </ToggleButtonGroup>
  );
};

export default SharePermissionToggle;
